import * as React from 'react';
import { Tooltip } from 'antd';
import { StyledInfoCircleOutlined } from './styled';

export interface InfoTooltipProps extends Omit<GetProps<typeof Tooltip>, 'children'> {
  children?: React.ReactNode;
}

const InfoTooltip = ({ children, ...props }: InfoTooltipProps) => {
  return <Tooltip {...props}>{children ?? <StyledInfoCircleOutlined />}</Tooltip>;
};

export default InfoTooltip;
